import axios from 'axios'

export const axiosInstance = axios.create({
    baseURL: 'https://api.therightguru.com/api',
    withCredentials: true
})
